import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'

import { getMenuItems } from '../../constants/navigationConfig'
import { RoleGuard } from '../RoleGuard/RoleGuard'

const Menu = () => {
    const menuItems = getMenuItems();

    // 渲染單個菜單項目或可折疊菜單
    const renderMenuItem = (item, index) => {
        // 菜單標題
        if (item.heading) {
            return (
                <div key={`heading-${index}`} className="sb-sidenav-menu-heading">
                    {item.heading}
                </div>
            );
        }

        // 可折疊菜單
        if (item.isCollapsible && item.items) {
            const collapseId = `collapse-${index}`;
            const menuElement = (
                <div key={`collapsible-${index}`}>
                    <Link
                        className="nav-link collapsed"
                        to="#"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${collapseId}`}
                        aria-expanded="false"
                        aria-controls={collapseId}
                        onClick={(e) => e.preventDefault()}
                    >
                        <div className="sb-nav-link-icon">
                            {typeof item.icon === 'string' ? (
                                <i className={`fas ${item.icon}`}></i>
                            ) : (
                                <FontAwesomeIcon icon={item.icon} />
                            )}
                        </div>
                        {item.label}
                        <div className="sb-sidenav-collapse-arrow">
                            <i className="fas fa-angle-down"></i>
                        </div>
                    </Link>
                    <div
                        className="collapse"
                        id={collapseId}
                        aria-labelledby={collapseId}
                        data-bs-parent="#sidenavAccordion"
                    >
                        <nav className="sb-sidenav-menu-nested nav">
                            {item.items.map((subItem, subIndex) => (
                                <RoleGuard key={`sub-${index}-${subIndex}`} requiredRole={subItem.requiredRole}>
                                    <Link
                                        className="nav-link"
                                        to={`/SKAManager${subItem.path}`}
                                    >
                                        {subItem.label}
                                    </Link>
                                </RoleGuard>
                            ))}
                        </nav>
                    </div>
                </div>
            );

            // 如果可折疊菜單有 requiredRole，用 RoleGuard 包裝
            if (item.requiredRole) {
                return (
                    <RoleGuard key={`collapsible-guard-${index}`} requiredRole={item.requiredRole}>
                        {menuElement}
                    </RoleGuard>
                );
            }
            return menuElement;
        }

        // 單層菜單項目
        if (!item.heading && !item.isCollapsible) {
            const path = item.external ? item.path : `/SKAManager${item.path}`;
            const handleClick = item.external ? () => localStorage.setItem('origin', 'home') : undefined;

            const menuElement = (
                <Link
                    className="nav-link"
                    to={path}
                    onClick={handleClick}
                >
                    <div className="sb-nav-link-icon">
                        {typeof item.icon === 'string' ? (
                            <i className={`fas ${item.icon}`}></i>
                        ) : (
                            <FontAwesomeIcon icon={item.icon} />
                        )}
                    </div>
                    {item.label}
                </Link>
            );

            // 如果有 requiredRole，用 RoleGuard 包裝
            if (item.requiredRole) {
                return (
                    <RoleGuard key={`item-guard-${index}`} requiredRole={item.requiredRole}>
                        {menuElement}
                    </RoleGuard>
                );
            }

            return (
                <div key={`item-${index}`}>
                    {menuElement}
                </div>
            );
        }

        return null;
    };

    return (
        <>
            <div id="layoutSidenav_nav">
                <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                    <div className="sb-sidenav-menu">
                        <div className="nav">
                            {menuItems.map((item, index) => renderMenuItem(item, index))}
                        </div>
                    </div>
                </nav>
            </div>
        </>
    )
}
export { Menu }